import { RangeSlider } from "../components/rangeSlider";
import { CmsmoduleInit } from "../cmsmodule/cmsmoduleInit";
import { TriggerReloadEvent } from "./triggerReloadEvent";
import { Beratung } from "../beratung";

/**
 * Initialisierung
 * wird als globales window object exportiert, damit es in der /js/cmsmodules.js Datei verwendet werden kann (z.b. nach ReloadModule (Filter setzen))
 */
export class MotionInit {
    constructor(viewRoot: HTMLElement) {
        new RangeSlider(viewRoot);
        new CmsmoduleInit(viewRoot);

        this.reinitializeOnReload();
        new Beratung(viewRoot);
    }

    /**
     * @see reloadManager.ts:reloadModule
     */
    private reinitializeOnReload() {
        document.addEventListener(
            "clxReloadModules",
            ((event: CustomEvent) => {
                new MotionInit(event.detail.viewRoot);
            }) as EventListener, // workaround for custom events
            { once: true },
        );
    }
}

// Export fuer globales window object
if (typeof window !== "undefined") {
    (window as any)["MotionInit"] = MotionInit;
}
